import React from 'react'
import * as H from 'history'
import { ISupportSpinner } from '../../shared/Ajax'
import { PrintBackButtons } from '../applicationForm-1/controls/PrintBackButtons'
import { Option } from '../../shared/fields/Options'
import { Consultant } from '../../models/Consultant'
import { ApplicationModel } from '../../models/ApplicationModel'
import { EligibleApplicantPage, PreviewObj } from './EligibleApplicantPage'
import { EligibleProductsPage } from './EligibleProductsPage'
import { EligibleExpensesPage } from './EligibleExpensesPage'
import { ApplicationFinalisationPage } from './ApplicationFinalisationPage'
import { FinancialYearModel } from '../../models/FinancialYearModel';
import { GUID } from '../../models/Guid'
import { EligibleTiersPage } from './EligibleTiers'


export interface PreviewPageProps {
  history: H.History
  model: ApplicationModel
  markets: Option<string>[]
  marketsKeyOnly: Option<string>[]
  marketRegions: string[]
  onChange: { (changes: Partial<ApplicationModel>): any }
  onSubmit: { (autoApplicationNumber: string, blobID: GUID): any }
  onPrint?: { (e: React.MouseEvent): any }
  print?: boolean
  consultants: Consultant[]
  addressCountries: Option<string>[]
  currentApplicationPeriod: FinancialYearModel
  financialYears: Option<string>[]
  eligibleExpenseCategories: Option<string>[]
  previewObj: PreviewObj
}

export interface PreviewPageState {
  loading: boolean
}

export class PreviewPage extends React.Component<PreviewPageProps, PreviewPageState> implements ISupportSpinner {
  constructor(props: PreviewPageProps) {
    super(props)
    this.state = {
      loading: false,
    }
  }

  componentDidMount() {
    const { print } = this.props
    if (print) window.print()
  }

  print = (e: React.MouseEvent) => {
    const { onPrint } = this.props
    if (onPrint) onPrint(e)
    else window.print()
  }

  back = () => {
    const { history } = this.props
    history.goBack()
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const { model, onPrint } = this.props

    return (
      <div>
        <PrintBackButtons onBack={this.back} onPrint={this.print} printLabel={onPrint ? 'Print to pdf' : 'Print'} />
        <div className="form-content-preview mt-4">
          <div style={{ margin: '4px 0px' }}>
            <span><strong>Application ID: </strong></span>
            <span id="claim-identifier-container">{model.claimRandomIdentifier || <span style={{ color: 'gray', fontStyle: 'italic' }}>Available when the application is submitted</span>}</span>
          </div>
          <div style={{ margin: '4px 0px' }}>
            <span><strong>Applicant Name: </strong></span>
            <span>{`${model.registeredBusinessName || ''}`}</span>
          </div>
          <div style={{ margin: '4px 0px' }}>
            <span><strong>Grant Year: </strong></span>
            <span>{model.financialYearName}</span>
          </div>
        </div>
        <EligibleApplicantPage {...this.props} preview />
        <EligibleTiersPage {...this.props} preview />
        <EligibleExpensesPage {...this.props} preview />
        <EligibleProductsPage {...this.props} preview />
        <ApplicationFinalisationPage {...this.props} preview />
        <PrintBackButtons onBack={this.back} onPrint={this.print} printLabel={onPrint ? 'Print to pdf' : 'Print'} />
      </div>
    )
  }
}
